export const getMinRangeValue = (
  rangeValue: number[] | undefined,
  minLimit: number,
  includeProductsWithIncopmleteData: boolean,
) => {
  const minLimitValue = !includeProductsWithIncopmleteData ? minLimit : undefined;

  return !!rangeValue?.[0] && rangeValue?.[0] !== minLimit ? rangeValue[0] : minLimitValue;
};
